<template>
  <naj-box
    :title="local.complaints.complaintDetails.requestLogInfo.title"
    header-icon="mdi-history"
    header-class="sub-header"
    disable-collapsing
  >
    <inspector-request-list
      v-if="complaint.clarificationRequestList && complaint.clarificationRequestList.length >0"
      :complaint="complaint"
    ></inspector-request-list>
    <user-request-list :complaint="complaint"></user-request-list>
  </naj-box>
</template>

<script>
import UserRequestList from './userRequestList.vue';
import InspectorRequestList from './inspectorRequestList.vue';
export default {
  name: 'RequestDetails',
  components: {
    UserRequestList,
    InspectorRequestList,
  },
  props: {
    complaint: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
</style>
